import {
  GENERATE_VOUCHER_REQUEST,
  GET_VOUCHER_REQUESTS_LIST_REQUEST,
  GET_VOUCHER_REQUESTS_LIST_RESPONSE,
  GET_VOUCHERS_USED_NOT_USED_LIST_REQUEST,
  GET_VOUCHERS_USED_NOT_USED_LIST_RESPONSE
} from "./types";

export const getVoucherRequestsListRequest = (payload) => ({
  type: GET_VOUCHER_REQUESTS_LIST_REQUEST,
  payload
});

export const getVoucherRequestsListResponse = (payload) => ({
  type: GET_VOUCHER_REQUESTS_LIST_RESPONSE,
  payload
});
export const getVouchersUsedNotUsedListRequest = (payload) => ({
  type: GET_VOUCHERS_USED_NOT_USED_LIST_REQUEST,
  payload
});

export const getVouchersUsedNotUsedListResponse = (payload) => ({
  type: GET_VOUCHERS_USED_NOT_USED_LIST_RESPONSE,
  payload
});

export const generateVoucherRequest = (payload) => ({
  type: GENERATE_VOUCHER_REQUEST,
  payload
});
